module.exports = __webpack_public_path__ + "static/media/logo_new.7ea48330.png";